export function getStrategySessionKey(
  client_id: string,
  strategy: string,
): string {
  return `${client_id}:${strategy}`;
}
